// Páginas legales / de cumplimiento (públicas, visibles sin login).
const meta = { layout: "full", resource: "Auth" }

export default [
  {
    path: "/terminos",
    name: "legal-terms",
    component: () => import("@/views/legal/TermsConditions.vue"),
    meta,
  },
  {
    path: "/privacidad",
    name: "legal-privacy",
    component: () => import("@/views/legal/PrivacyPolicy.vue"),
    meta,
  },
  {
    path: "/seguridad",
    name: "legal-security",
    component: () => import("@/views/legal/SecurityPolicy.vue"),
    meta,
  },
  {
    path: "/devoluciones",
    name: "legal-refunds",
    component: () => import("@/views/legal/RefundPolicy.vue"),
    meta,
  },
  {
    path: "/entrega",
    name: "legal-delivery",
    component: () => import("@/views/legal/DeliveryPolicy.vue"),
    meta,
  },
  {
    path: "/contacto",
    name: "legal-contact",
    component: () => import("@/views/legal/Contact.vue"),
    meta,
  },
  {
    path: "/servicios",
    name: "legal-services",
    component: () => import("@/views/legal/Services.vue"),
    meta,
  },
]
